import {regNavn} from "../../../../../felles/tjenester/tredjepartsTjenestenavn";
import {l} from "../../../../../types/typescriptdefinisjoner_lederplan";
import {Debugger} from "debug";
import {MdDialogController} from "../../../../tjenester/Dialog";
import {EnumOversettelser} from "felles/tjenester/i18n/EnumOversettelser";
import {IPromise} from "angular";
import _, {isNumber} from "lodash";
import {GruppeRessurs} from "../../../../../felles/tjenester/ressurser/GruppeRessurs";
import {gettextCatalog} from "angular-gettext";
import {MeldingTilBruker} from "../../../../../felles/tjenester/MeldingTilBruker";

const debug: Debugger = require('debug')('ForfalteOppgaverDokumentValgDialog');
require('./forfalteOppgaverDokumentValgDialog.scss');


export class ForfalteOppgaverDokumentValgDialog implements MdDialogController {

    static visForfalteOppgaverDokumentValgDialog($mdDialog: angular.material.IDialogService, gruppeId: string): IPromise<void> {
        debug('visForfalteOppgaverDokumentValgDialog')
        return $mdDialog.show(this.dialogKonfigurasjon({gruppeId: gruppeId}));
    }

    private static dialogKonfigurasjon(locals: Object): angular.material.IDialogOptions {
        return {
            template: require('./forfalteOppgaverDokumentValgDialog.html'),
            controller: ForfalteOppgaverDokumentValgDialog.forInjisering(),
            controllerAs: '$ctrl',
            bindToController: true,
            locals: locals
        };
    }

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            GruppeRessurs.regNavn,
            EnumOversettelser.regNavn,
            MeldingTilBruker.regNavn,
            regNavn.gettext.gettextCatalog,
            ForfalteOppgaverDokumentValgDialog
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService,
                private gruppeRessurs: GruppeRessurs,
                private enumOversettelser: EnumOversettelser,
                private meldingtilBruker: MeldingTilBruker,
                private gettextCatalog: gettextCatalog
    ) {
    }

    gruppeId: string; // settes via locals
    modell: UtelattForelderType[];
    ingenDelerValgt = false;
    lagrer = false;

    avbryt() {
        this.$mdDialog.cancel();
    }

    $onInit() {
        this.modell = _.toArray(l.OppgaveForelderType)
            .filter(isNumber)
            .map(forelderType => ({
                ikkeUtelatt: true,
                initielltIkkeUtelatt: true,
                enumVerdi: forelderType,
                navn: this.enumOversettelser.oversettDokumentForelder(forelderType)
            }));

        this.gruppeRessurs.hent(this.gruppeId).$promise
            .then(gruppe => {
                gruppe.oppsett.forfalteOppgaverDokumentValg.utelatteForelderTyper
                    .map(utelatt => this.modell.find(kandidat => kandidat.enumVerdi === utelatt))
                    .forEach(modell => modell.ikkeUtelatt = modell.initielltIkkeUtelatt = false);
                this.beregnAntallUtelatte();
            });
    }

    lagre() {
        if (!this.modell.some(modell => modell.ikkeUtelatt != modell.initielltIkkeUtelatt)) {
            //ingen endringer
            this.$mdDialog.hide();
            return;
        }

        this.lagrer = true;

        const utelatteForelderTyper = this.modell
          .filter(modell => !modell.ikkeUtelatt)
          .map(modell => modell.enumVerdi);

        this.gruppeRessurs.oppdaterForfalteOppgaverDokumentValg(this.gruppeId, {utelatteForelderTyper: utelatteForelderTyper}).$promise
          .then(() => {
              this.$mdDialog.hide();
              this.meldingtilBruker.infomelding(this.gettextCatalog.getString("Oppgavedokument-oppsett er lagret!"));
          })
          .finally(this.lagrer = false)
    }

    beregnAntallUtelatte() {
        debug('antUtelatte');
        const antallUtelatte = this.modell
          .filter(modell => !modell.ikkeUtelatt)
          .length;
        this.ingenDelerValgt = antallUtelatte == this.modell.length;
    }
}

interface UtelattForelderType {
    enumVerdi: l.OppgaveForelderType;
    navn: string;
    ikkeUtelatt: boolean;
    initielltIkkeUtelatt: boolean;
}
